var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestionsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2005 18.756V18.4455C17.2005 17.4285 17.829 16.878 18.459 16.455C19.074 16.041 19.6905 15.501 19.6905 14.505C19.6905 13.1295 18.576 12.0165 17.202 12.0165C15.828 12.0165 14.712 13.128 14.712 14.5035",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.199 22.2645C17.0745 22.2645 16.974 22.365 16.9755 22.4895C16.9755 22.614 17.076 22.7145 17.2005 22.7145C17.325 22.7145 17.4255 22.614 17.4255 22.4895C17.4255 22.365 17.325 22.2645 17.199 22.2645",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7945 28.9739C21.843 30.0689 19.596 30.7004 17.2005 30.7004C9.744 30.7004 3.7005 24.6569 3.7005 17.2004C3.7005 9.74394 9.744 3.70044 17.2005 3.70044C24.657 3.70044 30.7005 9.74394 30.7005 17.2004C30.7005 19.5974 30.069 21.8444 28.974 23.7944L30.7005 30.7004L23.7945 28.9739Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QuestionsIcon.6493af94.svg";
export { ForwardRef as ReactComponent };